import React, { useState, useEffect } from "react";
import { FormGroup, Input } from 'reactstrap';
import { Col, Row, Container, Label, Button } from "reactstrap";
import TextareaAutosize from 'react-textarea-autosize';
import ApiCaller from "../../api/apiCaller";
import "./index.scss";

const Help = () => {
  const [ticket, setTicker] = useState({
    summary: '',
    description: '',
    key: '',
    self: '',
    priority_id: '3',
  });
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const updateAttr = (attrName:string, value:any) => {
    setTicker({
      ...ticket,
      [attrName]: value,
    });
  };
  const submitTicket = async () => {
    setIsSubmitting(true);
    const uri = 'help/ticket';
    const res = await ApiCaller.post(
      uri,
      ticket,
    );
    if (res.status === 'ok') {
      setSubmitSuccess(true);
      const newTicker = res.ticket;
      setTicker({
        ...ticket,
        ...newTicker,
      });
      setIsSubmitting(false);
    } else {
      alert(res.message);
      setIsSubmitting(false);
    }
  }
  if (submitSuccess) {
    return (
      <Container className="submit-ticket__container">
        <Row>
          <Col xs={12}>
            <h1 className="submit-ticket__page-title">
              Đã gửi ticket thành công, chúng tôi sẽ phản hồi lại sớm nhất cho bạn
            </h1>
            <p className="submit-ticket__title">Mã ticket: <b>{ticket.key}</b></p>
          </Col>
        </Row>
      </Container>
    );
  }
  return (
    <Container className="submit-ticket__container">
      <Row>
        <Col xs={12}>
          <h1 className="submit-ticket__page-title">Gửi trợ giúp</h1>
        </Col>
      </Row>
      <Row className="section">
        <Col xs={12}>
          <FormGroup>
            <Label className="submit-ticket__title">Vài chữ mô tả ngắn gọn về vấn đề của bạn</Label>
            <Input
              className="submit-ticket__control"
              placeholder="Tiêu đề"
              onChange={e => updateAttr('summary', e.target.value)}
              value={ticket.summary}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label className="submit-ticket__title">Mức độ ảnh hưởng</Label>
            <Input
              type="select"
              value={ticket.priority_id}
              onChange={e => updateAttr('priority_id', e.target.value)}
            >
              <option value="2">High (lỗi, nhưng không làm gián đoạn việc)</option>
              <option value="3">Medium</option>
              <option value="4">Low</option>
              <option value="10001">Minor</option>
              <option value="10000">Blocker (việc đang không chạy)</option>
            </Input>
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label className="submit-ticket__title">Bạn gặp vấn đề với tính năng nào, nó không hoạt động ra sao, mô tả lỗi giúp team LISA nhé</Label>
            <TextareaAutosize
              className="form-control submit-ticket__control"
              placeholder="Mô tả chi tiết vấn đề"
              minRows={4}
              onChange={e => updateAttr('description', e.target.value)}
              value={ticket.description}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <Button
            className="submit-ticket__submit-button"
            color="primary"
            onClick={submitTicket}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Đang gửi...' : 'Gửi'}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Help;